import { useEffect, useState ,useCallback } from "react";

// const ScrollTop = () =>{

const ScrollTop = ()=> {


    const [showButton, setShowButton] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    function logit() {
        setScrollY(window.pageYOffset);
        window.pageYOffset > 400 ? setShowButton(true) : setShowButton(false) ;
        // console.log(window.pageYOffset);
    }

    useEffect(() => {
        function watchScroll() {
        window.addEventListener("scroll", logit);
        }
        watchScroll();
            return () => {
            window.removeEventListener("scroll", logit);
        };
    },[]);

  

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="delay-1000	ease-in-out duration-1000">
            {showButton && (
                    <button onClick={scrollToTop} className="back-to-top delay-1000	ease-in-out duration-1000">
                        {/* &#8679; */}
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" className="w-4 h-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path></svg>
                    </button>
                )
            }
        </div>                
    
    )
}
export default ScrollTop ; 
